import { createSlice } from '@reduxjs/toolkit';
import apiClient from 'root/lib/apiClient';
import isBrowser from 'utils/isBrowser';
import { Sentry } from 'root/utils/raven';

const initialState = {
  items: {},
  isLoading: true,
  error: null,
};

const articlesSlice = createSlice({
  name: 'articles',
  initialState,
  reducers: {
    getArticleStart(state) {
      state.isLoading = true;
    },
    getArticleSuccess(state, { payload: { permalink, data } }) {
      state.items[permalink] = data;
      state.isLoading = false;
      state.error = null;
    },
    getArticleFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getArticleStart,
  getArticleSuccess,
  getArticleFailure,
} = articlesSlice.actions;

export default articlesSlice.reducer;

export const fetchArticle = (permalink) => async (dispatch, getState) => {
  const { articles } = getState();
  if (articles.items[permalink] && !articles.items[permalink]?.length) {
    dispatch(getArticleSuccess({
      permalink,
      data: articles.items[permalink],
    }));
  } else {
    try {
      dispatch(getArticleStart());
      const { content } = await apiClient({ method: 'GET', url: '/wp-json/mc/v2/router', params: { permalink } });
      dispatch(getArticleSuccess({
        permalink,
        data: content,
      }));
    } catch (e) {
      dispatch(getArticleFailure(e.toString()));
      Sentry.captureException(e);
    }
  }
};

export const fetchArticlePreview = (id, wpnonce, cookie) => async (dispatch) => {
  const url = `/wp-json/mc/v1/posts/${id}/?_wpnonce=${wpnonce}`;
  const config = {
    withCredentials: true,
  };

  if (isBrowser()) {
    config.headers = {
      Cookie: cookie,
    };
  }

  try {
    dispatch(getArticleStart());
    const data = await apiClient({ method: 'GET', url, params: { config } });
    dispatch(getArticleSuccess({
      slug: id,
      data,
    }));
  } catch (e) {
    dispatch(getArticleFailure(e.toString()));
    Sentry.captureException(e);
  }
};

export const setArticle = ({ permalink, data }) => getArticleSuccess({
  permalink,
  data,
});
